module.exports = __webpack_public_path__ + "img/5diamonds.056d79db.jpg";